/**
 * Invisible characters that Excel/Google Sheets/macOS clipboard pastes embed:
 * zero-width spaces and joiners, bidi marks, invisible math operators, BOM,
 * soft hyphen, NBSP and narrow NBSP (macOS puts U+202F before AM/PM in copied
 * times). They survive into submitted values, where backend parsers and
 * validators reject or misread them — dates fall through to a day-first
 * fallback and silently swap month/day.
 */
const INVISIBLE_CHARS = /[\u200B-\u200F\u2060-\u2064\uFEFF\u00AD\u00A0\u202F]/g;

export function sanitizeClipboardText(value: string): string {
  return value.replace(INVISIBLE_CHARS, ' ').replace(/\s+/g, ' ').trim();
}

/**
 * Sanitizes a Handsontable paste payload in place — the shape the
 * `beforePaste` hook provides and expects mutated.
 */
export function sanitizeClipboardGrid(data: string[][]): void {
  for (const row of data) {
    for (let i = 0; i < row.length; i++) {
      const value = row[i];
      if (typeof value === 'string') {
        row[i] = sanitizeClipboardText(value);
      }
    }
  }
}
